import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import timeSince from "./../../../../api/utils/timeSince";
import BarLoader from "./../../../common/Loader/BarLoader";
import Highlight from "./highLight";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ConversationCard = _ref => {
  let {
    conversation,
    onClick,
    activeConversationId,
    currentEmployeeId,
    searchValue
  } = _ref;
  const participants = get(conversation, 'participants', []);
  const isActive = activeConversationId && conversation.sid === activeConversationId;
  const otherParticipant = participants.find(p => (p === null || p === void 0 ? void 0 : p.id) !== currentEmployeeId);
  const lastMessageDate = get(conversation, 'lastMessageDate', null);
  const unreadMessages = get(conversation, 'unreadMessages');
  const clientName = get(conversation, 'attributes.client.name', false);
  const topicName = get(conversation, 'attributes.service.name', false);
  const otherParticipantsName = get(otherParticipant, 'name', false);
  const otherParticipantsProviderName = get(otherParticipant, 'provider.name', false);
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(conversation.sid);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    role: "button",
    tabIndex: 0,
    className: "p-15 mb-4 cursor-pointer",
    style: {
      backgroundColor: "#EEF5FC",
      padding: "14.5px",
      margin: '0 0 16px',
      borderLeft: "".concat(isActive ? '2px solid #4467AB' : ''),
      paddingLeft: "".concat(isActive ? '12.5px' : '14.5px')
    },
    onClick: () => onClick(conversation.sid),
    onKeyDown: handleKeyDown,
    "data-value": conversation.sid,
    "aria-label": "Message to Client: ".concat(clientName || 'Unknown', " Topic: ").concat(topicName || 'Unknown'),
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex mb-4",
      "aria-hidden": true,
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-3/4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "text-left",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "mb-4",
            children: [clientName ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("span", {
                className: unreadMessages ? "strong" : "font-regular-font",
                children: "Client:"
              }), ' ', /*#__PURE__*/_jsxs("span", {
                className: unreadMessages ? "strong" : "font-regular-font",
                children: [/*#__PURE__*/_jsx(Highlight, {
                  text: clientName,
                  highlight: searchValue
                }), " |", ' ']
              })]
            }) : /*#__PURE__*/_jsx(BarLoader, {}), topicName ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("span", {
                className: unreadMessages ? "strong" : "font-regular-font",
                children: "Topic:"
              }), ' ', /*#__PURE__*/_jsx("span", {
                className: unreadMessages ? "strong" : "font-regular-font",
                children: /*#__PURE__*/_jsx(Highlight, {
                  text: topicName,
                  highlight: searchValue
                })
              })]
            }) : /*#__PURE__*/_jsx(BarLoader, {})]
          }), /*#__PURE__*/_jsxs("p", {
            className: unreadMessages ? 'strong' : '',
            children: [otherParticipantsName ? /*#__PURE__*/_jsx(Highlight, {
              text: otherParticipantsName,
              highlight: searchValue
            }) : /*#__PURE__*/_jsx(BarLoader, {}), ' ', "(", otherParticipantsProviderName ? /*#__PURE__*/_jsx(Highlight, {
              text: otherParticipantsProviderName,
              highlight: searchValue
            }) : /*#__PURE__*/_jsx(BarLoader, {}), ")"]
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: unreadMessages ? "w-1/4 h-12 text-right strong" : "w-1/4 h-12 text-right font-regular-font",
        children: [lastMessageDate ? timeSince(lastMessageDate) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("div", {
          className: "mt-4",
          children: unreadMessages ? /*#__PURE__*/_jsx("div", {
            className: "float-right w-2 h-2 rounded-full bg-blue"
          }) : ''
        })]
      })]
    })
  });
};
ConversationCard.defaultProps = {
  conversation: {
    sid: '',
    lastmessageDate: function () {
      return new Date();
    },
    unreadmessages: false,
    topic: {
      name: ''
    },
    person: {
      full_name: ''
    },
    participants: [{
      id: '',
      full_name: ''
    }]
  },
  onClick: null,
  activeConversationId: '',
  currentEmployeeId: ''
};
ConversationCard.propTypes = {
  conversation: PropTypes.shape({
    sid: PropTypes.string,
    lastMessageDate: PropTypes.instanceOf(Date),
    unreadMessages: PropTypes.bool,
    topic: PropTypes.shape({
      name: PropTypes.string
    }),
    person: PropTypes.shape({
      full_name: PropTypes.string
    }),
    participants: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      full_name: PropTypes.string
    }))
  }),
  onClick: PropTypes.func,
  activeConversationId: PropTypes.string,
  currentEmployeeId: PropTypes.string
};
export default ConversationCard;
//# sourceMappingURL=conversationCard.js.map